import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";

export const ToastCloseButton = ({closeToast}) => (
    <IconButton style={{color: "#fff"}} onClick={closeToast}>
        <CloseIcon/>
    </IconButton>
);
